import { Pipe } from '@angular/core';
var IsNotIdenticalToPipe = (function () {
    function IsNotIdenticalToPipe() {
    }
    IsNotIdenticalToPipe.prototype.transform = function (input, other) {
        return input !== other;
    };
    return IsNotIdenticalToPipe;
}());
export { IsNotIdenticalToPipe };
IsNotIdenticalToPipe.decorators = [
    { type: Pipe, args: [{ name: 'isNotIdenticalTo' },] },
];
/** @nocollapse */
IsNotIdenticalToPipe.ctorParameters = function () { return []; };
//# sourceMappingURL=is-not-identical-to.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-pipes/esm/pipes/boolean/is-not-identical-to.js
// module id = 228
// module chunks = 4